import { render, staticRenderFns } from "./ButtonOptionalSquare.vue?vue&type=template&id=5eb57f8a&scoped=true&lang=pug&"
import script from "./ButtonOptionalSquare.vue?vue&type=script&lang=ts&"
export * from "./ButtonOptionalSquare.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonOptionalSquare.vue?vue&type=style&index=0&id=5eb57f8a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb57f8a",
  null
  
)

export default component.exports